import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from "@angular/core";
import { environment } from "src/environments/environment";
import { ActivatedRoute } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { QuotingToolService } from "../../quoting-tool.service";
import { UploadDocument } from "src/app/core/interfaces/quoting-tool";
import { NotificationService } from "src/app/core/services/notification.service";
import { AddCadFile, AddGerberCadFile, AddGerberFile, SignUpNDA } from "src/app/core/interfaces/quoting-tool";
import { MatStepper } from '@angular/material/stepper';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import * as $ from 'jquery';

declare var bootstrap: any;
declare global {
interface JQuery {
    modal(action?: string): JQuery;
  }
}
@Component({
  selector: "app-upload-files",
  templateUrl: "./upload-files.component.html"
})
export class UploadFilesComponent implements OnInit {
  
  @ViewChild("fileInputGerber") fileInputGerber!: ElementRef<HTMLInputElement>;
  @ViewChild("fileInputCAD") fileInputCAD!: ElementRef<HTMLInputElement>;
  @ViewChild('stepper') private myStepper!: MatStepper;
  @Output() skipStep = new EventEmitter<void>();
  @Output() nextStep = new EventEmitter<void>();

  @Output() stepStatusUpdate = new EventEmitter<{ index: number, status: string, completed: boolean }>();

  signNdaForm!: FormGroup;
  NdaFormSubmitted = false;
  isFormInvalid: boolean = true;
  isLoading: boolean = false;
  getImagePath: any = environment.image_path;
  gerberFile: File | null = null;
  cadFile: File | null = null;
  gerberProgress: number = 0;
  cadProgress: number = 0;
  showGerberUploading: boolean = false;
  showCADUploading: boolean = false;
  isNextButtonDisabled = true; 
  isFileUploaded = false;
  
  gerberInterval: any;
  cadInterval: any;

  @Input('projectType') projectType: any;
  projectID: any;
  image :any
  gerberData: any;
  cadData: any;
  newImagePath: string = 'assets/images/checked_check_box.svg';
  isNdaSigned: boolean = false; // Track NDA signed status
  modalInstance: any;
  tokenPresent: any;
  
  constructor(private route: ActivatedRoute, private http: HttpClient, private quotingService: QuotingToolService, private notificationService: NotificationService) { }

  onSkipStep() {
    this.skipStep.emit();
  }

  ngOnInit(): void {
    this.projectID = localStorage.getItem('projectID');
    this.image = localStorage.getItem('newImagePath');
    let quote_token = localStorage.getItem('quote_token');
    this.tokenPresent = quote_token ? quote_token : localStorage.getItem('customer_access_token');
    this.isNdaSigned = localStorage.getItem('isNdaSigned') === 'true';

    this.gerberData = localStorage.getItem('gerberFile');
    this.cadData = localStorage.getItem('cadFile');

    if(this.tokenPresent){
      this.GetRfcDocumentation();
    }

    if (this.gerberData) {
      this.gerberFile = JSON.parse(this.gerberData);
      this.isNextButtonDisabled = false;
    }
    if (this.cadData) {
      this.cadFile = JSON.parse(this.cadData);
    }

    this.signNdaForm = new FormGroup({
      vLocation : new FormControl(""), 
      name: new FormControl("", [Validators.required,Validators.maxLength(100),Validators.pattern('^[A-Za-z0-9][A-Za-z0-9 ]*$')]),
      designation: new FormControl("", [Validators.required,Validators.maxLength(100),Validators.pattern('^\\S.*$')]),
      companyName: new FormControl("", [Validators.required,Validators.maxLength(100),Validators.pattern('^[A-Za-z0-9][A-Za-z0-9 ]*$')]),
      companyRegistered: new FormControl("", [Validators.required,Validators.maxLength(100),Validators.pattern('^\\S.*$')]),
      businessEmailAddress: new FormControl("", [Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]),

    });
  }

  ngAfterViewInit(): void {
    // this.projectType = localStorage.getItem('projectType');
    const modalElement = document.getElementById('exampleModal') as HTMLElement;
    this.modalInstance = new bootstrap.Modal(modalElement, {
      backdrop: 'static', 
      keyboard: false    
    }); 
  };

  CheckIfInvalid() {
    if (this.signNdaForm.invalid) {
      this.isFormInvalid = true;
    } else {
      this.isFormInvalid = false;
    }
  }

  GetRfcDocumentation(){
    this.quotingService.GetRfcLocation(this.projectID).subscribe(async (resJSON: any) => {
        if (resJSON.code == 200) {
          this.isNextButtonDisabled = false; 
          // this.gerberFile = resJSON.data.vGerberFileName
          if(resJSON.data.vGerberFileName){
            localStorage.setItem('gerberFile', JSON.stringify({ name: resJSON.data.vGerberFileName, type:'gerber' }));
          }
          this.gerberFile = JSON.parse(this.gerberData);
          localStorage.setItem('gerberFilePath',resJSON.data.vGerberFileName)
        }
      })
  }

  // NdaForm() {
  //   this.NdaFormSubmitted = true;

  //   // Check if the form is invalid
  //   if (this.signNdaForm.invalid) {
  //     // Display error messages for all fields
  //     Object.keys(this.signNdaForm.controls).forEach((field) => {
  //       const control = this.signNdaForm.get(field);
  //       if (control) {
  //         control.markAsTouched({ onlySelf: true });
  //       }
  //     });
  //     return;
  //   }
  // }

  // Function to handle file upload
  
  handleFileUpload(event: Event, type: string) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (file) {
      if (type === 'gerber') {
        this.uploadFile(file, type);
      } else if (type === 'cad') {
        this.uploadFile(file, type);
      }
    }
  }

  uploadFile(file: File, type: string) {
    const reqJSON: UploadDocument = {
      vProjectID: this.projectID,
    };

    if (type === 'gerber') {
      reqJSON.garberZip = file;
      reqJSON.vProjectType = 1;
    } else if (type === 'cad') {
      reqJSON.cadZip = file;
      reqJSON.vProjectType = 2;
    }

    this.quotingService
      .UploadDocument(this.createFormData(reqJSON, type))
      .subscribe(async (resJSON: any) => {
        if (resJSON.code == 200) {
          if (reqJSON.vProjectType == 1) {
            this.showGerberUploading = true;
            this.gerberFile = file;
            this.simulateProgress('gerber');
            localStorage.setItem('gerberFile', JSON.stringify({ name: file.name, type }));
            const gerberFileName = resJSON.data[0].garberFilePath.gaberFileName;
            localStorage.setItem('gerberFilePath', gerberFileName)
            // this.notificationService.showSuccess(`${resJSON.message}`, "");
          } else if (reqJSON.vProjectType == 2) {
            this.showCADUploading = true;
            this.cadFile = file;
            this.simulateProgress('cad');
            localStorage.setItem('cadFile', JSON.stringify({ name: file.name, type }));
            const cadFileName = resJSON.data[0].cadFilePath.cadFileName;
            localStorage.setItem('cadFilePath', cadFileName)
            // this.notificationService.showSuccess(`${resJSON.message}`, "");
          }
        } else {
          this.showGerberUploading = false;
          this.gerberProgress = 0;
          this.gerberFile = null;
          this.gerberData = false;
          clearInterval(this.gerberInterval); // Clear the interval
          this.fileInputGerber.nativeElement.value = ''; // Clear the file input
          localStorage.removeItem('gerberFile');
          localStorage.removeItem('gerberFilePath');
          this.notificationService.showError(`${resJSON.message}`, "");
        }
      })
  }

  createFormData(body: UploadDocument, type: string): FormData {
    const formData = new FormData();

    if (type === 'gerber') {
      formData.append('vProjectID', body.vProjectID);
      formData.append('vProjectType', body.vProjectType!.toString());
      formData.append('garberZip', body.garberZip!, body.garberZip!.name);
      return formData;
    } else if (type === 'cad') {
      formData.append('vProjectID', body.vProjectID);
      formData.append('vProjectType', body.vProjectType!.toString());
      formData.append('cadZip', body.cadZip!, body.cadZip!.name);
      return formData;
    }
    else{
      throw new Error(`Unsupported type: ${type}`);
    }
  }

  CheckUploadFiles() {
    if (this.projectType == 1) {
      const GerberFileName = localStorage.getItem('gerberFilePath')
      const reqJSON: AddGerberFile = {
        vProjectID: this.projectID,
        vProjectType: Number(this.projectType),
        vFormStep: 1,
        vGerberFile: GerberFileName || ''
      }
      this.quotingService
        .AddGerberFile(reqJSON)
        .subscribe(async (resJSON: any) => {
          if (resJSON.code == 200) {
            this.nextStep.emit();
            this.notificationService.showSuccess(`${resJSON.message}`, "");
            localStorage.setItem('upload_gerber','true');
            const newValue = Math.random() * 100;
            this.quotingService.updateStepper(newValue);
          } else {
            this.notificationService.showError(`${resJSON.message}`, "");
          }
        })
    }

    if (this.projectType == 2) {
      const CadFileName = localStorage.getItem('cadFilePath')
      const reqJSON: AddCadFile = {
        vProjectID: this.projectID,
        vProjectType: Number(this.projectType),
        vFormStep: 1,
        vCADFile: CadFileName || ''
      }
      this.quotingService
        .AddCadFile(reqJSON)
        .subscribe(async (resJSON: any) => {
          if (resJSON.code == 200) {
            this.notificationService.showSuccess(`${resJSON.message}`, "");
          } else {
            this.notificationService.showError(`${resJSON.message}`, "");
          }
        })
    }

    if (this.projectType == 3) {
      const GerberFileName = localStorage.getItem('gerberFilePath');
      const CadFileName = localStorage.getItem('cadFilePath');
      const reqJSON: AddGerberCadFile = {
        vProjectID: this.projectID,
        vProjectType: Number(this.projectType),
        vFormStep: 1,
        vGerberFile: GerberFileName || '',
        vCADFile: CadFileName || ''
      }
      this.quotingService
        .AddGerberCadFile(reqJSON)
        .subscribe(async (resJSON: any) => {
          if (resJSON.code == 200) {
            this.notificationService.showSuccess(`${resJSON.message}`, "");
          } else {
            this.notificationService.showError(`${resJSON.message}`, "");
          }
        })
    }
  }

  // Simulate progress for file upload
  simulateProgress(type: string) {
    let progress = 0;
    const interval = setInterval(() => {
      progress += 20;
      if (type === 'gerber') {
        this.gerberProgress = Math.min(progress, 100); // Ensure progress doesn't exceed 100%
        if (progress >= 100) {
          clearInterval(interval); // Stop the interval when progress reaches 100%
          setTimeout(() => {
            this.showGerberUploading = false; // Hide the uploading section
          }, 100);
          this.notificationService.showSuccess("File Uploaded Successfully");
          this.isNextButtonDisabled = false; 
        }
      } else if (type === 'cad') {
        this.cadProgress = Math.min(progress, 100);
        if (progress >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            this.showCADUploading = false;
          }, 500);
        }
      }
    }, 600); // Update progress every second

    // Store the interval for later use
    if (type === 'gerber') {
      this.gerberInterval = interval;
    } else if (type === 'cad') {
      this.cadInterval = interval;
    }
  }
  // Function to cancel file upload
  cancelFileUpload(type: string) {
    if (type === 'gerber') {
      this.showGerberUploading = false;
      this.gerberProgress = 0;
      this.gerberFile = null;
      localStorage.removeItem('gerberFile');
      localStorage.removeItem('gerberFilePath');
      this.gerberData = false;
      clearInterval(this.gerberInterval); // Clear the interval
      this.fileInputGerber.nativeElement.value = ''; // Clear the file input
    } else if (type === 'cad') {
      this.showCADUploading = false;
      this.cadProgress = 0;
      this.cadFile = null;
      localStorage.removeItem('cadFile');
      localStorage.removeItem('cadFilePath');
      this.cadData = false;
      clearInterval(this.cadInterval); // Clear the interval
      this.fileInputCAD.nativeElement.value = ''; // Clear the file input
    }
  }

  SignUpNDA() {
     if (this.signNdaForm.invalid) {
      this.notificationService.showError("Please fill in all required fields.", "");
      return;
    }
    const reqJSON: SignUpNDA = {
      vLocation : this.signNdaForm.value.vLocation,
      vUsername: this.signNdaForm.value.name,
      vDesignation: this.signNdaForm.value.designation,
      vCompanyname: this.signNdaForm.value.companyName,
      vCompanyRegistered: this.signNdaForm.value.companyRegistered,
      vBusinessEmail: this.signNdaForm.value.businessEmailAddress
    };
    localStorage.setItem('newImagePath', this.newImagePath);
    this.quotingService.SignUpNDA(this.projectID,reqJSON).subscribe((resJSON: any) => {
      if (resJSON.code == 200) {
        this.signNdaForm.reset();
        this.notificationService.showSuccess(`${resJSON.message}`, "");
        this.isLoading = false;
        localStorage.setItem('isNdaSigned', 'true');
        this.isNdaSigned = true;
        this.modalInstance.hide();
      } else {
        this.isLoading = false;
        this.notificationService.showError(`${resJSON.message}`, "");
      }
    })
  }

  CloseModal() {  
     if (this.signNdaForm.invalid) {
      // Display error messages for all fields
      Object.keys(this.signNdaForm.controls).forEach((field) => {
        const control = this.signNdaForm.get(field);
        if (control) {
          control.markAsDirty({ onlySelf: true });
        }
      });
      return;
    } else {
      this.SignUpNDA();
      this.modalInstance.hide();
    }
  }
}
